import { Component, OnInit, ViewChild } from '@angular/core';
import { MedicinePackageService } from "../../../../services/medicine-package.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from "../../../../services/global.service";
import swal from 'sweetalert2'
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
@Component({
  selector: 'app-setting-medicine-package',
  templateUrl: './setting-medicine-package.component.html',
  styleUrls: ['./setting-medicine-package.component.scss']
})
export class SettingMedicinePackageComponent implements OnInit {

  medicine_packages: MatTableDataSource<any>;
  medicinesPackageForm: FormGroup;
  filtersForm: FormGroup;
  submitted = false;

  displayedColumns: string[] = ['index', 'name', 'action']
  @ViewChild(MatSort) sort: MatSort
  @ViewChild(MatPaginator) paginator: MatPaginator
  constructor(
    private MedicinePackageService: MedicinePackageService,
    private formBuilder: FormBuilder,
    private Global: GlobalService
  ) { }

  ngOnInit() {
    this.getMedicinePackages()
    this.setFiltersForm()
    this.setForm()
  }

  setFiltersForm() {
    this.filtersForm = this.formBuilder.group({
      keywords: ''
    });
  }

  setForm() {
    this.medicinesPackageForm = this.formBuilder.group({
      name: ['', Validators.required]
    });
  }

  showForm(medicine_packages = null) {
    this.submitted = false;
    if (medicine_packages != null) {
      this.medicinesPackageForm = this.formBuilder.group({
        name: [medicine_packages.name, Validators.required],
        id: medicine_packages['id']
      });
    }
    else {
      this.setForm()
    }
  }

  getMedicinePackages() {
    var filters = {}
    if (this.filtersForm) {
      filters['keywords'] = this.filtersForm.value.keywords
    }

    this.MedicinePackageService.getMedicinePackages(filters).subscribe(data => {
      let medicine_packages
      medicine_packages = data
      let array = medicine_packages.map((item, index) => {
        item.index = index + 1
        return item
      })
      this.medicine_packages = new MatTableDataSource(array)
      this.medicine_packages.sort = this.sort
      this.medicine_packages.paginator = this.paginator
    })
  }

  get f() { return this.medicinesPackageForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.medicinesPackageForm.invalid) {
      return;
    }
    const fd = new FormData();
    swal({
      title: 'ยืนยันการบันทึก',
      text: "คุณต้องการบันทึกข้อมูลใช่หรือไม่ ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#36a3f7',
      cancelButtonColor: '#f4516c',
      confirmButtonText: 'ใช่, บันทึกข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        fd.append('medicine_package[name]', this.medicinesPackageForm.controls.name.value)
        var medicine_package_id = ''
        if (this.medicinesPackageForm.controls.id) {
          medicine_package_id = this.medicinesPackageForm.controls.id.value
        }
        this.MedicinePackageService.submitMedicinePackage(fd, medicine_package_id).subscribe(res => {
          if (res['error']) {
            swal({
              type: 'warning',
              title: 'การบันทึกข้อมูลผิดพลาด',
              showConfirmButton: true,
            })
          }
          else {
            swal({
              type: 'success',
              title: 'บันทึกข้อมูลเรียบร้อยแล้ว',
              showConfirmButton: false,
              timer: 1500
            })
            this.getMedicinePackages();
            this.setForm()
            this.submitted = false
            this.Global.loadScript('assets/script/modal.js');
          }
        })
      }
    })
  }

  delete(id) {
    swal({
      title: 'ยืนยันการลบข้อมูล',
      text: "คุณต้องการลบข้อมูลใช่หรือไม่ ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#36a3f7',
      cancelButtonColor: '#f4516c',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.MedicinePackageService.deleteMedicinePackage(id).subscribe(res => {
          swal({
            type: 'success',
            title: 'ลบข้อมูลเรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          })
          this.getMedicinePackages();
        })
      }
    })
  }

}
